import { useMutation, UseMutationResult } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'

interface PropsDeleteDoseAditivos {
  doses_remover: number[]
  cod: number
  refetch: Function
}

interface PropsDeleteAditivos  {
  cod_aditivos: number
  refetch_deletar: Function
}

export const usePutRemoverDose = (): {
  carregando_remover_dose: boolean
  mutate_remover_dose: (params: PropsDeleteDoseAditivos) => void
  isSuccess_remover_dose: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsDeleteDoseAditivos> = useMutation(
    async (params: PropsDeleteDoseAditivos) => {
      const { cod, doses_remover, refetch } = params
      return api
        .post(`/recomendacao/aditivo/${cod}?codConta=${localConfig()?.conta}`, {
          doses_remover: doses_remover,
        })
        .then((response: any) => {
          doses_remover.length > 0 &&
            successAlert('Dose cultura removido com sucesso!', 5000, 'remove_ativo')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              doses_remover.length > 0 &&
                errorAlert(data?.msg[0] ?? 'Falha ao remover dose cultura!', 5000, 'remove_ativo')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao remover dose cultura!', 5000, 'teste')
          }

          throw error
        })
    }
  )

  return {
    carregando_remover_dose: mutation.isLoading,
    mutate_remover_dose: mutation.mutate,
    isSuccess_remover_dose: mutation.isSuccess,
  }
}

export const useDeleteAditivo = (): {
  carregando_deletar_aditivos: boolean
  mudateDeletarAditivos : (params: PropsDeleteAditivos ) => void
} => {
  const mutation: UseMutationResult<Response, Error, PropsDeleteAditivos > = useMutation(
    async (params: PropsDeleteAditivos ) => {
      const { cod_aditivos, refetch_deletar } = params

      const config = localConfig()

      loadingAlert({ msg: 'Excluindo...', id: 'delete_aditivos' })

      return api
        .delete(`/recomendacao/aditivo/${cod_aditivos}?codConta=${config.conta}`)
        .then((response: any) => {
          successAlert('Excluído com sucesso!', 5000, 'delete_aditivos')
          refetch_deletar?.()
          return response
        })
        .catch((error: Error) => {
          //@ts-ignore
          let error_response = error?.response?.data
          errorAlert(
            error_response?.error ?? 'Falha ao excluir aditivo',
            5000,
            'delete_aditivos'
          )

          throw error
        })
    }
  )

  return {
    carregando_deletar_aditivos: mutation.isLoading,
    mudateDeletarAditivos: mutation.mutate,
  }
}